<template>
	<div>
  		<router-view />
	</div>
</template>

<script>
export default {
  	components: {
      	AppToolbar: () => import('@/components/core/AppToolbar')
  	}, 
    methods : {
    },
    mounted() 
    {

    },
    destroyed()
    {

    }
}
</script>

<style lang="css" scoped>
</style>
